module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_9005.83c44fd9.png";